module.exports = __webpack_public_path__ + "img/logo.23ef80d8.png";